import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { emptyArr } from 'util/arrays'

import { Flex, Icon } from 'shared/ui'

import Recipient from './Recipient'

const flexStyle = css`
  flex: 1 0 90%;
`

const Header = ({
  className,
  label,
  recipients = emptyArr,
  twitterRecipients,
}) => {
  return (
    <Flex className={className}>
      <Flex css={flexStyle} className="grui overflow-hidden">
        <Icon name="twitter" size="small" color="color.externalBrand.twitter" />
        <div className="grui ml-4">
          <Recipient
            label={label}
            recipients={twitterRecipients || recipients}
          />
        </div>
      </Flex>
    </Flex>
  )
}

export default styled(Header)`
  flex-shrink: 0;
  margin: 0 -${props => props.theme.spacing['10']} ${props => props.theme.spacing['5']};
  padding: ${props => props.theme.spacing['3']}
    ${props => props.theme.spacing['10']};
  border-bottom: 1px solid ${props => props.theme.color.monochrome.light};
  border-top: 1px solid ${props => props.theme.color.monochrome.light};
  background-color: ${props => props.theme.color.monochrome.superLight};
  white-space: nowrap;
`
